/* eslint-disable @typescript-eslint/no-unused-vars */
import storeInfo from '../store'
import { TosCheckType } from './types'

export const isTosChecked = (): TosCheckType => {
  const { tosCheck } = storeInfo.store.getState()
  return tosCheck || false
}
